import React, { useCallback } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import AlterDomainBR from '@/media/onboarding/temporary-domain-br.png';
import AlterDomainES from '@/media/onboarding/temporary-domain-es.webp';
import { BuyPlanStepProps } from './UpgradePlanStep.types';
import { isBRServer } from '@/utils/Validators/validation';
import * as Styles from './UpgradePlanStep.styles';
import { IconCheck } from 'gatorcomponents';
import { WHMCS_URL } from '@/config';


const BuyPlanStep = ({
  locales,
  buttonsProps,
  hostingId,
}) => {
  const handleRedirect = useCallback(() => {
    window.location.href = `${WHMCS_URL}/index.php?m=custom_upgrade&action=selectupgrade&id=${hostingId}`;
  }, [hostingId]);

  const stepProps = useCallback(() => {
    const customButtonsProps = {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        onClick: handleRedirect,
      },
    };

    return {
      imageSrc: isBRServer ? AlterDomainBR : AlterDomainES,
      buttonsProps: customButtonsProps,
    };
  }, [
    buttonsProps,
    handleRedirect,
  ]);

  return (
    <>
      <GenericStep {...stepProps()}>
        <Styles.Title>{locales.title}</Styles.Title>
        <Styles.Subtitle>{locales.subtitle}</Styles.Subtitle>
        <Styles.Description>{locales.description}</Styles.Description>

        <Styles.List>
          {locales.list.map(item => (
            <Styles.ListItem key={item}>
              <IconCheck color="primaryMedium" />
              {item}
            </Styles.ListItem>
          ))}
        </Styles.List>
      </GenericStep>
    </>
  );
};

BuyPlanStep.propTypes = BuyPlanStepProps;

export default BuyPlanStep;
